async function main() {
    await import('./lit-hydration.js');
    import('./finn-topbar.js');
}
export default main();
